module.exports = __webpack_public_path__ + "img/资源看板.e55ed284.png";